export const ON_LOGGEDIN = "loginReducer/ON_LOGGEDIN";
export const LOAD_USER_SESSION = "loginReducer/LOAD_USER_SESSION";

export const onLoggedin = (val) => (disptch) => {
  disptch({
    type: ON_LOGGEDIN,
    payload: val,
  });
};


